<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Perguntas
              <p class="category" style="text-transform: none">Crie aqui suas perguntas</p>
              <div class="d-flex">
                <div class="search-control" style="max-width: 240px">
                  <input class="form-control" type="text" placeholder="Buscar" v-model="search" v-on:keyup.enter="doSearch(search)" />
                </div>

                <div class="ml-1 d-flex">
                  <div v-click-outside="closeDropdown" class="dropdown dropdown-black" :class="{ show: filterBranch }">
                    <button @click="filterBranch = !filterBranch" class="btn btn-secondary form-control dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <label id="lblDropdown" class="form-check-label" style="font-weight: 500" v-if="noTypeSelected">Filtrar por tipo</label>
                      <span v-else class="d-inline-flex badge badge-primary mr-2">
                        {{ selectedBranch.label }}
                        <span class="bgc badge__close" @click="(selectedBranch = ''), doSearch()">
                          <i class="vs-icon-close vs-icon-hover-less"></i>
                        </span>
                      </span>
                    </button>
                    <div class="dropdown-menu dropdown-black" aria-labelledby="dropdownMenuButton">
                      <div class="dropdown-body scroll-custom" style="max-height: 320px; overflow: auto">
                        <div class="px-3" v-if="questionTypes.length > 0">
                          <div style="color: #fff; cursor: pointer" class="form-check" v-for="b in questionTypes" :key="b.id" @click="selectedBranch = { id: b.id, label: b.label, type: b.type }">
                            {{ b.label }}
                          </div>
                        </div>
                        <p class="dropdown-item" v-else>Nenhum resultado encontrado</p>
                      </div>
                    </div>
                  </div>
                </div>

                <button class="search__btn" @click="doSearch(search)">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </h4>
            <div class="col-lg-6 d-flex align-items-end justify-content-end mb-3 flex-wrap">
              <button class="btn btn-info btn-sm" @click="openModalQuestionCampaign()">Adicionar Pergunta + Pesquisa</button>
              <button class="btn btn-info btn-sm" @click="visibilityStates.createVisibility = true">Adicionar Pergunta</button>
            </div>
          </div>

          <Table :tableData="questionsTableData" :data="questions" :columns="['id', 'type', 'content', 'actions']" :actions="['view']" @pagechanged="onPageChange" @openDetailsModal="openDetailsModal"> </Table>
          <ListLoader v-if="questionsTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!questionsTableData.loading && questionsTableData.error"></Error>
          <Empty v-if="!questionsTableData.loading && !questionsTableData.error && questions.length === 0"></Empty>
        </card>
      </div>
    </div>

    <Modal v-model="visibilityStates.readVisibility" action="Ok" title="Detalhes da pergunta" @closeModal="visibilityStates.readVisibility = false" @confirmAction="visibilityStates.readVisibility = false">
      <template v-slot:body>
        <div v-if="question.type === 'brand' || question.type === 'trick'">
          <div class="form-group">
            <label>Tipo da pergunta</label>
            <input type="text" class="form-control" :placeholder="question.type" disabled />
          </div>

          <div class="form-group">
            <label>Nome da Marca</label>
            <input type="text" class="form-control" :placeholder="question.brands.name" disabled />
          </div>
        </div>

        <div v-if="question.type === 'profile'">
          <div class="form-group">
            <label>Identificador da pergunta de perfil</label>
            <input type="text" class="form-control" :placeholder="question.typeResponse" disabled />
          </div>

          <div class="form-group">
            <label>Texto da Pergunta</label>
            <input type="text" class="form-control" :placeholder="question.profileQuestion" disabled />
          </div>

          <div class="form-group">
            <label>Imagem da Pergunta</label>
            <img v-if="question.imageName" class="mb-3" style="display: block; max-width: 100px" :src="question.image_url" />
            <div style="font-size: 10px" v-else>Nenhuma imagem cadastrada</div>
          </div>
        </div>

        <div v-if="question.type === 'widget'">
          <div class="form-group">
            <label>Tipo da pergunta</label>
            <input type="text" class="form-control" placeholder="Widget" disabled />
          </div>
          <div class="form-group">
            <label>Settings (JSON)</label>
            <textarea class="form-control" rows="6" :value="JSON.stringify(question.settings, null, 2)" disabled />
          </div>
        </div>
      </template>
    </Modal>

    <Modal
      v-model="visibilityStates.createVisibility"
      successMessage="Pergunta criada com sucesso!"
      :buttonDisabled="buttonDisabled"
      action="Adicionar"
      title="Adicionar Pergunta"
      @closeModal="(newQuestion = {}), (visibilityStates.createVisibility = false)"
      @confirmAction="create(newQuestion)"
    >
      <template v-slot:body>
        <div class="form-group">
          <label>Qual o tipo de pergunta?</label>
          <select v-model="newQuestion.type" class="form-control">
            <option value="brand">Marcas</option>
            <option value="trick">Trick</option>
            <option value="tips">Dicas</option>
            <option value="profile">Perfil</option>
            <option value="widget">Widget</option>
          </select>
        </div>

        <div v-if="newQuestion.type === 'tips'" class="form-group">
          <div class="form-group">
            <label>Insira o texto da dica</label>
            <textarea class="form-control" v-model="newQuestion.typeResponse" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'profile'" class="form-group">
          <div class="form-group">
            <label>Selecione a Pergunta de Perfil</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="allProfiles" :flat="false" :normalizer="normalizerProfiles" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'trick'" class="form-group">
          <div class="form-group">
            <label>Selecione a marca</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="brands" :flat="false" :normalizer="normalizerTricks" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'brand'" class="form-group">
          <div class="form-group">
            <label>Selecione a marca</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="brands" :flat="false" :normalizer="normalizerBrands" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'widget'" class="form-group">
          <div class="form-group">
            <label>Configurações (JSON)</label>
            <textarea class="form-control" rows="6" v-model="newQuestion.settings" />
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      v-model="visibilityStates.turboCreateVisibility"
      successMessage="Pergunta criada com sucesso!"
      :buttonDisabled="buttonDisabled"
      action="Adicionar"
      title="Adicionar Pergunta + Pesquisa"
      @closeModal="closeModalQuestionCampaign()"
      @confirmAction="createQuestionTurbo(newQuestion)"
    >
      <template v-slot:body>
        <div class="form-group">
          <label>Qual o tipo de pergunta?</label>
          <select v-model="newQuestion.type" class="form-control">
            <option value="brand">Marcas</option>
            <option value="trick">Trick</option>
            <option value="tips">Dicas</option>
            <option value="profile">Perfil</option>
            <option value="widget">Widget</option>
          </select>
        </div>

        <div v-if="newQuestion.type === 'tips'" class="form-group">
          <div class="form-group">
            <label>Insira o texto da dica</label>
            <textarea class="form-control" v-model="newQuestion.typeResponse" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'profile'" class="form-group">
          <div class="form-group">
            <label>Selecione a Pergunta de Perfil</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="allProfiles" :flat="false" :normalizer="normalizerProfiles" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'trick'" class="form-group">
          <div class="form-group">
            <label>Selecione a marca</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="brands" :flat="false" :normalizer="normalizerTricks" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'brand'" class="form-group">
          <div class="form-group">
            <label>Selecione a marca</label>
            <treeselect v-model="newQuestion.brandsId" :multiple="false" :options="filteredBrands" :flat="false" :normalizer="normalizerBrands" />
          </div>
        </div>

        <div v-if="newQuestion.type === 'widget'" class="form-group">
          <div class="form-group">
            <label>Configurações (JSON)</label>
            <textarea class="form-control" rows="6" v-model="newQuestion.settings" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Empty from '@/components/Common/Empty';
import Modal from '@/components/Modal/Modal';
import Search from '@/components/Common/Search';
import Table from '@/components/Common/Table';
import TotalRegisters from '@/components/Common/TotalRegisters';
import Treeselect from '@riophae/vue-treeselect';
import api from '@/api.js';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Empty,
    Modal,
    Search,
    Table,
    TotalRegisters,
    Treeselect,
  },
  data() {
    return {
      temporaryImage: null,
      visibilityStates: {
        turboCreateVisibility: false,
        createVisibility: false,
        editVisibility: false,
        readVisibility: false,
      },
      page: 1,
      newQuestion: {},
      search: '',
      filterBranch: false,
      selectedBranch: '',
      inputBranch: '',
      abc: {},
      questionTypes: [
        {
          id: 0,
          type: 'profile',
          label: 'Perfil',
        },
        {
          id: 1,
          type: 'brand',
          label: 'Marca',
        },
        {
          id: 2,
          type: 'trick',
          label: 'Trick',
        },
        {
          id: 3,
          type: 'widget',
          label: 'Widget',
        },
      ],
      filterPage: 0,
      filter: {},
    };
  },
  watch: {
    'newQuestion.type'(newType) {
      if (newType === 'widget') {
        const defaultSettings = {
          amount: 0.10,
          api_key: 'xxxxx',
          form_id: 1,
          journey: 'flex-journey',
          store_id: '1',
          employee_id: '1',
        };
        this.newQuestion.settings = JSON.stringify(defaultSettings, null, 2);
      }
    },
  },
  computed: {
    currentPage() {
      return this.$store.getters['questions/currentPage'];
    },
    questions() {
      return this.$store.getters['questions/getQuestions'];
    },
    questionsTableData() {
      return this.$store.getters['questions/getQuestionsTableData'];
    },
    question() {
      return this.$store.getters['questions/getQuestion'];
    },
    allQuestions() {
      return this.$store.getters['questions/getAllQuestions'];
    },
    brands() {
      return this.$store.getters['brands/getAllBrands'];
    },
    noTypeSelected() {
      return this.selectedBranch === '';
    },
    filteredBranches() {
      return this.branches.filter((s) => s.name.toLowerCase().includes(this.inputBranch.toLowerCase()));
    },
    branches() {
      return this.$store.getters['branches/getBranches'];
    },
    allProfiles() {
      return this.$store.getters['profiles/getAllProfiles'];
    },
    buttonDisabled() {
      if (this.newQuestion.type == undefined) {
        return true;
      }
      if (this.newQuestion.type === 'widget') {
        return !this.newQuestion.settings;
      }
      if (this.newQuestion.type === 'tips') {
        return !this.newQuestion.typeResponse;
      }
      return this.newQuestion.brandsId == undefined;
    },
    filteredBrands() {
      return this.brands.filter((s) => !this.allQuestions.map((a) => a.brandsId).includes(s.id));
    },
  },
  methods: {
    openDetailsModal: async function (id) {
      await this.$store.dispatch('questions/getQuestionById', id);
      this.visibilityStates.readVisibility = true;
    },
    handleFileUpload: async function (type) {
      this.file = this.$refs.file.files[0];
      this.submitFile(type);
    },
    submitFile: async function (type) {
      let formData = new FormData();
      formData.append('image', this.file);

      if (type === 'add') {
        this.temporaryImage = formData;
      }
    },

    create: async function () {
      const payload = this.buildPayload();
      await this.$store.dispatch('questions/create', payload);
    },
    createQuestionTurbo: async function () {
      const payload = this.buildPayload();

      const payloadQuestion = { brandsId: payload.brandsId, profileId: payload.profileId, type: payload.type, settings: payload.settings };
      const questionId = await this.$store.dispatch('questions/create', payloadQuestion);
      if (questionId != undefined) {
        try {
          const { data } = await api.get(`/surveys`);
          const payloadCampaign = { order: data.length, questionId };
          await api.post(`surveys`, payloadCampaign);
          this.showNotifications('success', 'Pesquisa criada com sucesso!');
        } catch (error) {
          this.showNotifications('danger', 'Erro ao criar a pesquisa');
        }
      }
    },
    buildPayload: function () {
      const payload = { type: this.newQuestion.type };

      if (payload.type === 'brand' || payload.type === 'trick') {
        payload.brandsId = this.newQuestion.brandsId;
      }

      if (payload.type === 'trick') {
        payload.brandsId = this.newQuestion.brandsId;
        payload.typeResponse = this.brands.find((s) => s.id === payload.brandsId).name;
      }

      if (payload.type === 'profile') {
        payload.brandsId = null;
        payload.profileId = this.newQuestion.brandsId;
      }

      if (payload.type === 'widget') {
        payload.settings = JSON.parse(this.newQuestion.settings);
        payload.brandsId = null;
      }

      return payload;
    },

    showNotifications(type, message) {
      this.$notify({
        icon: 'tim-icons icon-bell-55',
        type: type,
        timeout: 3000,
        message: message,
      });
    },

    normalizerTricks(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    normalizerBrands(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    normalizerProfiles(node) {
      return {
        id: node.id,
        label: node.slug,
      };
    },
    closeDropdown: function (event) {
      this.filterBranch = false;
    },
    doSearch: async function (search) {
      let payload = {};

      payload.search = search;
      payload.limit = 10;
      payload.page = this.filterPage !== 0 ? this.filterPage : 1;

      if (!this.noTypeSelected) {
        payload.extraParams = { name: 'type', id: this.selectedBranch.type };
      }
      if (this.search === '' && this.noTypeSelected) {
        this.$store.dispatch('questions/setPage', 1);
      } else {
        this.$store.dispatch('questions/searchQuestion', payload);
      }
      this.filter = payload;
      payload = {};
    },
    onPageChange(page) {
      if (this.filter !== {}) {
        this.filter.search = this.filter.search ? this.filter.search : '';
        this.filter.limit = 10;
        this.filter.page = page;
        this.$store.dispatch('questions/searchQuestion', this.filter);
      } else {
        this.$store.dispatch('questions/setPage', page);
      }
    },
    closeModalQuestionCampaign() {
      this.newQuestion = {};
      this.visibilityStates.turboCreateVisibility = false;
      this.$store.dispatch('questions/resetPagination');
    },
    openModalQuestionCampaign() {
      this.visibilityStates.turboCreateVisibility = true;
      this.$store.dispatch('questions/getQuestionsNoLimit');
    },
  },

  mounted() {
    this.$store.dispatch('profiles/getAllProfiles');
    this.$store.dispatch('brands/getBrandsNoLimit');
    this.$store.dispatch('questions/getQuestionsNoLimit');
    this.$store.dispatch('questions/resetPagination');
  },
};
</script>
<style scoped>
select option {
  color: #039be5 !important;
}
</style>
